(function () {
  "use strict";

  function initReveal() {
    var els = document.querySelectorAll(".mt-reveal");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("mt-visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18, rootMargin: "0px 0px -8% 0px" }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initContadores() {
    var els = document.querySelectorAll("[data-mt-contador]");
    if (!els.length) return;
    var animado = new WeakSet();
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || animado.has(entry.target)) return;
          animado.add(entry.target);
          var el = entry.target;
          var fin = parseFloat(el.getAttribute("data-mt-contador")) || 0;
          var decimales = (el.getAttribute("data-mt-decimales") || "0") === "1" ? 1 : 0;
          var duracion = 1400;
          var inicio = null;
          function paso(ts) {
            if (!inicio) inicio = ts;
            var progreso = Math.min((ts - inicio) / duracion, 1);
            var facil = 1 - Math.pow(1 - progreso, 3);
            var valor = fin * facil;
            el.textContent = decimales ? valor.toFixed(1) : Math.round(valor);
            if (progreso < 1) requestAnimationFrame(paso);
            else el.textContent = decimales ? fin.toFixed(1) : fin;
          }
          requestAnimationFrame(paso);
        });
      },
      { threshold: 0.6 }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initCarruselResenas() {
    var carruseles = document.querySelectorAll("[data-mt-carrusel]");
    carruseles.forEach(function (carrusel) {
      var pista = carrusel.querySelector("[data-mt-pista]");
      var puntos = carrusel.querySelectorAll("[data-mt-punto]");
      var prev = carrusel.querySelector("[data-mt-prev]");
      var next = carrusel.querySelector("[data-mt-next]");
      if (!pista) return;
      var tarjetas = pista.children.length;
      var indice = 0;

      function ir(i) {
        indice = (i + tarjetas) % tarjetas;
        var tarjeta = pista.children[indice];
        pista.scrollTo({ left: tarjeta.offsetLeft - pista.offsetLeft, behavior: "smooth" });
        puntos.forEach(function (p, idx) { p.classList.toggle("mt-activo", idx === indice); });
      }
      if (prev) prev.addEventListener("click", function () { ir(indice - 1); });
      if (next) next.addEventListener("click", function () { ir(indice + 1); });
      puntos.forEach(function (p, idx) {
        p.addEventListener("click", function () { ir(idx); });
      });
    });
  }

  function initSelectorVariantes() {
    var forms = document.querySelectorAll("[data-mt-producto-form]");
    forms.forEach(function (form) {
      var dataEl = form.querySelector("[data-mt-variantes-json]");
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var contenedor = form.closest("[data-mt-producto-contenedor]") || form;
      var inputId = form.querySelector("input[name='id']");
      var precioEl = contenedor.querySelector("[data-mt-precio]");
      var precioTachadoEl = contenedor.querySelector("[data-mt-precio-tachado]");
      var botonComprar = form.querySelector("[data-mt-boton-comprar]");
      var opciones = form.querySelectorAll("[data-mt-opcion]");

      function formatoDinero(centavos) {
        return (centavos / 100).toLocaleString(document.documentElement.lang || "es", {
          style: "currency",
          currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "EUR",
        });
      }

      function seleccionActual() {
        return Array.prototype.map.call(opciones, function (grupo) {
          var activo = grupo.querySelector(".mt-swatch--activo, .mt-opcion-valor--activo");
          return activo ? activo.getAttribute("data-valor") : null;
        });
      }

      function encontrarVariante() {
        var seleccion = seleccionActual();
        return variantes.find(function (v) {
          return v.options.every(function (op, idx) { return op === seleccion[idx]; });
        });
      }

      function actualizar() {
        var variante = encontrarVariante();
        if (!variante) return;
        if (inputId) inputId.value = variante.id;
        if (precioEl) precioEl.textContent = formatoDinero(variante.price);
        if (precioTachadoEl) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            precioTachadoEl.textContent = formatoDinero(variante.compare_at_price);
            precioTachadoEl.style.display = "";
          } else {
            precioTachadoEl.style.display = "none";
          }
        }
        if (botonComprar) {
          if (variante.available) {
            botonComprar.disabled = false;
            botonComprar.textContent = botonComprar.getAttribute("data-texto-disponible") || botonComprar.textContent;
          } else {
            botonComprar.disabled = true;
            botonComprar.textContent = botonComprar.getAttribute("data-texto-agotado") || "Agotado";
          }
        }
        var idParam = variante.featured_image ? variante.featured_image.id : null;
        if (idParam) {
          var miniatura = document.querySelector('[data-mt-miniatura-media="' + idParam + '"]');
          if (miniatura) miniatura.click();
        }
      }

      opciones.forEach(function (grupo) {
        var etiquetaActual = grupo.querySelector("[data-mt-opcion-actual]");
        grupo.querySelectorAll("[data-valor]").forEach(function (btn) {
          btn.addEventListener("click", function () {
            grupo.querySelectorAll("[data-valor]").forEach(function (b) {
              b.classList.remove("mt-swatch--activo", "mt-opcion-valor--activo");
            });
            btn.classList.add(btn.classList.contains("mt-swatch") ? "mt-swatch--activo" : "mt-opcion-valor--activo");
            if (etiquetaActual) etiquetaActual.textContent = btn.getAttribute("data-valor");
            actualizar();
          });
        });
      });

      actualizar();
    });
  }

  function initGaleriaProducto() {
    var galerias = document.querySelectorAll("[data-mt-galeria]");
    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector("[data-mt-imagen-principal]");
      var miniaturas = galeria.querySelectorAll("[data-mt-miniatura-media]");
      if (!principal) return;
      miniaturas.forEach(function (mini, idx) {
        mini.addEventListener("click", function () {
          var src = mini.getAttribute("data-full");
          if (!src) return;
          principal.style.opacity = 0;
          setTimeout(function () {
            principal.src = src;
            principal.style.opacity = 1;
          }, 120);
          miniaturas.forEach(function (m) { m.classList.remove("mt-miniatura--activa"); });
          mini.classList.add("mt-miniatura--activa");
          galeria.setAttribute("data-mt-indice-actual", idx);
        });
      });
    });
  }

  function initNivelesCantidad() {
    var grupos = document.querySelectorAll("[data-mt-niveles-cantidad]");
    grupos.forEach(function (grupo) {
      var form = grupo.closest("form");
      if (!form) return;
      var cantidadInput = form.querySelector("[data-mt-cantidad]");
      var niveles = grupo.querySelectorAll("[data-mt-nivel]");
      niveles.forEach(function (nivel) {
        nivel.addEventListener("click", function () {
          niveles.forEach(function (n) { n.classList.remove("mt-nivel-cantidad--activo"); });
          nivel.classList.add("mt-nivel-cantidad--activo");
          if (cantidadInput) cantidadInput.value = nivel.getAttribute("data-mt-nivel");
        });
      });
    });
  }

  function initLightboxProducto() {
    var galerias = document.querySelectorAll("[data-mt-galeria]");
    galerias.forEach(function (galeria) {
      var lightbox = galeria.parentElement ? galeria.parentElement.querySelector("[data-mt-lightbox]") : null;
      if (!lightbox) return;
      var dataEl = lightbox.querySelector("[data-mt-lightbox-json]");
      var fotos = [];
      try { fotos = JSON.parse((dataEl && dataEl.textContent) || "[]"); } catch (e) { fotos = []; }
      if (!fotos.length) return;

      var imgEl = lightbox.querySelector("[data-mt-lightbox-imagen]");
      var contadorEl = lightbox.querySelector("[data-mt-lightbox-contador]");
      var abrirBtn = galeria.querySelector("[data-mt-abrir-lightbox]");
      var principal = galeria.querySelector("[data-mt-imagen-principal]");
      var cerrarBtn = lightbox.querySelector("[data-mt-lightbox-cerrar]");
      var prevBtn = lightbox.querySelector("[data-mt-lightbox-prev]");
      var nextBtn = lightbox.querySelector("[data-mt-lightbox-next]");
      var indice = 0;

      function mostrar(i) {
        indice = (i + fotos.length) % fotos.length;
        imgEl.src = fotos[indice].src;
        imgEl.alt = fotos[indice].alt || "";
        if (contadorEl) contadorEl.textContent = (indice + 1) + " / " + fotos.length;
      }

      function abrir() {
        var actual = parseInt(galeria.getAttribute("data-mt-indice-actual"), 10) || 0;
        mostrar(actual);
        lightbox.style.display = "flex";
        lightbox.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";
      }

      function cerrar() {
        lightbox.style.display = "none";
        lightbox.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
      }

      if (abrirBtn) abrirBtn.addEventListener("click", abrir);
      if (principal) principal.addEventListener("click", abrir);
      if (cerrarBtn) cerrarBtn.addEventListener("click", cerrar);
      if (prevBtn) prevBtn.addEventListener("click", function () { mostrar(indice - 1); });
      if (nextBtn) nextBtn.addEventListener("click", function () { mostrar(indice + 1); });
      lightbox.addEventListener("click", function (e) {
        if (e.target === lightbox) cerrar();
      });
      document.addEventListener("keydown", function (e) {
        if (lightbox.style.display !== "flex") return;
        if (e.key === "Escape") cerrar();
        if (e.key === "ArrowLeft") mostrar(indice - 1);
        if (e.key === "ArrowRight") mostrar(indice + 1);
      });
    });
  }

  function initPolicyAccordion() {
    // Delegado en document: el texto de las políticas nativas de Shopify no
    // admite <details>/<summary> (se eliminan al guardar), así que el
    // acordeón se construye con <div> normales y se abre/cierra por clase.
    document.addEventListener("click", function (e) {
      var head = e.target.closest(".mt-policy-acc__head");
      if (!head) return;
      var item = head.closest(".mt-policy-acc");
      if (item) item.classList.toggle("mt-policy-acc--open");
    });
  }

  // Protección de envío "Secure Unlimited®" opcional: el envío estándar
  // va siempre incluido (es el único método activo en Shopify), esto solo
  // añade/quita del carrito un producto aparte que representa el seguro.
  var MT_PROTECTION_PRODUCT_ID = 16113223827800;
  var MT_PROTECTION_VARIANT_ID = 58807132815704;

  function mtRefreshCartAndPublish(source) {
    if (!window.routes || !window.routes.cart_url) return;
    fetch(window.routes.cart_url + ".js")
      .then(function (response) { return response.json(); })
      .then(function (cartData) {
        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: source, cartData: cartData });
        }
      })
      .catch(function () {});
  }

  function initShippingProtectionToggle() {
    document.addEventListener("change", function (e) {
      var toggle = e.target.closest("[data-mt-protection-toggle]");
      if (!toggle || !window.routes) return;

      var adding = toggle.checked;
      var row = toggle.closest(".mt-protection-row");
      if (row) row.classList.add("mt-protection-row--loading");
      toggle.disabled = true;

      var request = adding
        ? fetch(window.routes.cart_add_url, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: [{ id: MT_PROTECTION_VARIANT_ID, quantity: 1 }] }),
          })
        : fetch(window.routes.cart_change_url, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ id: String(MT_PROTECTION_VARIANT_ID), quantity: 0 }),
          });

      request
        .then(function (response) {
          if (!response.ok) throw new Error("cart request failed");
          return response.json();
        })
        .then(function () {
          mtRefreshCartAndPublish("mt-protection-toggle");
        })
        .catch(function () {
          toggle.checked = !adding;
          toggle.disabled = false;
          if (row) row.classList.remove("mt-protection-row--loading");
        })
        .finally(function () {
          toggle.disabled = false;
          if (row) row.classList.remove("mt-protection-row--loading");
        });
    });
  }

  function initShippingProtectionAutoClean() {
    // Si se queda la protección sola en el carrito (sin ningún producto
    // real), la quitamos automáticamente: no tiene sentido pagar un seguro
    // de envío sin nada que proteger.
    if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cartData = event && event.cartData;
      if (!cartData || !cartData.items) return;
      var hasProtection = false;
      var hasRealItem = false;
      cartData.items.forEach(function (item) {
        if (item.product_id === MT_PROTECTION_PRODUCT_ID) {
          hasProtection = true;
        } else {
          hasRealItem = true;
        }
      });
      if (!hasProtection || hasRealItem) return;

      fetch(window.routes.cart_change_url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: String(MT_PROTECTION_VARIANT_ID), quantity: 0 }),
      })
        .then(function () { mtRefreshCartAndPublish("mt-protection-autoclean"); })
        .catch(function () {});
    });
  }

  // Formatea céntimos según el money_format de la tienda (window.shopMoneyFormat,
  // fijado en theme.liquid). Implementación mínima del formato de Shopify.
  function mtFormatMoney(cents, format) {
    var formatString = format || window.shopMoneyFormat || "${{amount}}";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    if (!match) return formatString;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === "undefined" ? 2 : precision;
      thousands = typeof thousands === "undefined" ? "," : thousands;
      decimal = typeof decimal === "undefined" ? "." : decimal;
      if (isNaN(number) || number === null) return "0";
      number = (number / 100).toFixed(precision);
      var parts = number.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : "";
      return dollars + centsPart;
    }

    var value;
    switch (match[1]) {
      case "amount_no_decimals":
        value = withDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = withDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = withDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_space_separator":
        value = withDelimiters(cents, 2, " ", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = withDelimiters(cents, 0, " ", "");
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function mtResizeImg(url, width) {
    if (!url) return url;
    return url.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, "_" + width + "x$1$2");
  }

  // Mismo mapa nombre-de-color → color real que snippets/mt-color-swatch.liquid
  // (usado en la ficha de producto). No es un color de Shopify, es una
  // aproximación visual honesta a partir del nombre del color/estampado.
  // Mantener sincronizado a mano con ese snippet si se añaden colores nuevos.
  var MT_COLOR_MAP = {
    "aqua": "#8fcfc9",
    "ash": "#b2aca4",
    "beige": "#e8dcc8",
    "beige & black": "linear-gradient(135deg, #e8dcc8 50%, #1a1614 50%)",
    "beige and black polka dots": "linear-gradient(135deg, #e8dcc8 50%, #1a1614 50%)",
    "black": "#1a1614",
    "black plaid": "#1a1614",
    "black/beige stripe": "linear-gradient(135deg, #e8dcc8 50%, #1a1614 50%)",
    "black/cream stripe": "linear-gradient(135deg, #1a1614 50%, #f3ecdd 50%)",
    "blue": "#4a6fa5",
    "blue stripe": "#4a6fa5",
    "butter pinstripe": "#f3e5ab",
    "buttercream": "#f5e7b8",
    "champagne": "#f0e2c0",
    "charcoal": "#4a4744",
    "choc micro polka": "#5c3a2e",
    "chocolate": "#5c3a2e",
    "chocolate & blue polka": "linear-gradient(135deg, #5c3a2e 50%, #4a6fa5 50%)",
    "chocolate & blue stripe": "linear-gradient(135deg, #5c3a2e 50%, #4a6fa5 50%)",
    "chocolate micro polka": "#5c3a2e",
    "chocolate micro polka print": "#5c3a2e",
    "chocolate polka print": "#5c3a2e",
    "chocolate and beige stripe": "linear-gradient(135deg, #5c3a2e 50%, #e8dcc8 50%)",
    "chocolate and blue stripe": "linear-gradient(135deg, #5c3a2e 50%, #4a6fa5 50%)",
    "chocolate and butter stripe": "linear-gradient(135deg, #5c3a2e 50%, #f3e5ab 50%)",
    "chocolate/butter": "linear-gradient(135deg, #5c3a2e 50%, #f3e5ab 50%)",
    "chocolate/butter stripe": "linear-gradient(135deg, #5c3a2e 50%, #f3e5ab 50%)",
    "cobalt": "#1e4c9a",
    "cobalt stripe": "#1e4c9a",
    "coffee": "#4b3621",
    "cream": "#f3ecdd",
    "dark chocolate with blue polka dots": "linear-gradient(135deg, #5c3a2e 50%, #4a6fa5 50%)",
    "dark khaki": "#6b6142",
    "dark navy": "#131b2e",
    "espresso/beige stripe": "linear-gradient(135deg, #3c2a1e 50%, #e8dcc8 50%)",
    "green": "#4f7a5a",
    "grey": "#8c8880",
    "grey marle": "#9c9890",
    "ice blue": "#c9e3ea",
    "ivory": "#f5f0e1",
    "laca cereza": "#7b1e2b",
    "leopard": "#a9855f",
    "light blue": "#a9c6de",
    "light blue and chocolate polka dot": "linear-gradient(135deg, #a9c6de 50%, #5c3a2e 50%)",
    "light pink": "#f3d1d9",
    "marfil": "#f5f0e1",
    "marine blue": "#1f3a5f",
    "mauve": "#9c7c82",
    "merlot and pink polka": "linear-gradient(135deg, #5e2233 50%, #e8a9b8 50%)",
    "midnight blue": "#10182b",
    "multicolor": "repeating-linear-gradient(135deg, #d9d3c7, #d9d3c7 4px, #efece3 4px, #efece3 8px)",
    "navy": "#1b2a4a",
    "olive": "#6b6b3a",
    "pastel pink": "#f6d9de",
    "pastel striped": "repeating-linear-gradient(135deg, #d9d3c7, #d9d3c7 4px, #efece3 4px, #efece3 8px)",
    "pink": "#e8a9b8",
    "pink & chocolate stripe": "linear-gradient(135deg, #5c3a2e 50%, #e8a9b8 50%)",
    "pink pinstripe": "#e8a9b8",
    "pink and red polka dots": "linear-gradient(135deg, #e8a9b8 50%, #b23a3a 50%)",
    "powder blue": "#b8d3e0",
    "purple": "#7a5c8e",
    "red": "#b23a3a",
    "rich chocolate": "#5c3a2e",
    "sand pinstripe": "#d8c9a3",
    "slate": "#5c6670",
    "sunny yellow": "#f0d04e",
    "taupe": "#a18e7c",
    "taupe plaid": "#a18e7c",
    "white": "#faf9f6",
    "white/black plaid": "linear-gradient(135deg, #1a1614 50%, #faf9f6 50%)",
    "wine": "#5e2233",
    "wine red": "linear-gradient(135deg, #5e2233 50%, #b23a3a 50%)",
    "yellow": "#f0d04e"
  };
  var MT_COLOR_FALLBACK = "repeating-linear-gradient(135deg, #d9d3c7, #d9d3c7 4px, #efece3 4px, #efece3 8px)";

  function mtSwatchColor(value) {
    var key = (value || "").trim().toLowerCase();
    return MT_COLOR_MAP[key] || MT_COLOR_FALLBACK;
  }

  // "You may also like" en el carrito: recomendaciones reales de Shopify
  // (basadas en el último producto real añadido), con selector de
  // talla/color y Añadir al carrito funcionando ahí mismo.
  function initCartRecommendations() {
    function realItems(cartData) {
      return (cartData.items || []).filter(function (item) {
        return item.product_id !== MT_PROTECTION_PRODUCT_ID;
      });
    }

    function renderRecoCard(product, preferredColor) {
      var card = document.createElement("div");
      card.className = "mt-reco-card";

      // product.options del endpoint de recomendaciones es una lista de
      // OBJETOS ({name, position, values}), no de simples textos — el
      // nombre real está en .name de cada uno.
      var optionNames = product.options || [];
      var sizeIndex = -1;
      var colorIndex = -1;
      optionNames.forEach(function (opt, i) {
        var lower = ((opt && opt.name) || "").toLowerCase();
        if (lower.indexOf("talla") !== -1 || lower.indexOf("size") !== -1) sizeIndex = i;
        if (lower.indexOf("color") !== -1 || lower.indexOf("colour") !== -1) colorIndex = i;
      });

      var selected = {};
      var availableVariants = product.variants.filter(function (v) { return v.available; });
      var firstAvailable = availableVariants[0] || product.variants[0];
      if (preferredColor && colorIndex !== -1) {
        var colorMatch = availableVariants.filter(function (v) {
          return v["option" + (colorIndex + 1)] === preferredColor;
        })[0];
        if (colorMatch) firstAvailable = colorMatch;
      }
      [0, 1, 2].forEach(function (i) {
        var key = "option" + (i + 1);
        if (firstAvailable && firstAvailable[key]) selected[i] = firstAvailable[key];
      });

      function findVariant() {
        return product.variants.filter(function (v) {
          return [0, 1, 2].every(function (i) {
            if (typeof selected[i] === "undefined") return true;
            return v["option" + (i + 1)] === selected[i];
          });
        })[0];
      }

      function uniqueValues(i) {
        var seen = [];
        product.variants.forEach(function (v) {
          var val = v["option" + (i + 1)];
          if (val && seen.indexOf(val) === -1) seen.push(val);
        });
        return seen;
      }

      function isValueAvailable(i, value) {
        return product.variants.some(function (v) {
          return v["option" + (i + 1)] === value && v.available;
        });
      }

      var imageWrap = document.createElement("a");
      imageWrap.className = "mt-reco-card__image";
      imageWrap.href = product.url;
      var img = document.createElement("img");
      img.loading = "lazy";
      img.alt = product.title;
      imageWrap.appendChild(img);
      card.appendChild(imageWrap);

      var infoEl = document.createElement("div");
      card.appendChild(infoEl);

      var titleLink = document.createElement("a");
      titleLink.href = product.url;
      titleLink.style.color = "inherit";
      titleLink.style.textDecoration = "none";
      var titleEl = document.createElement("p");
      titleEl.className = "mt-reco-card__title";
      titleEl.textContent = product.title;
      titleLink.appendChild(titleEl);
      infoEl.appendChild(titleLink);

      var priceEl = document.createElement("p");
      priceEl.className = "mt-reco-card__price";
      infoEl.appendChild(priceEl);

      var optionsEl = document.createElement("div");
      optionsEl.className = "mt-reco-card__options";
      infoEl.appendChild(optionsEl);

      var addBtn = document.createElement("button");
      addBtn.type = "button";
      addBtn.className = "mt-reco-card__add";
      infoEl.appendChild(addBtn);

      function updateUI() {
        var variant = findVariant();
        var fallbackImg = product.images && product.images[0];
        var imgSrc = (variant && variant.featured_image && variant.featured_image.src) || fallbackImg;
        img.src = mtResizeImg(imgSrc, 300);
        priceEl.textContent = mtFormatMoney(variant ? variant.price : product.variants[0].price);
        var canBuy = !!(variant && variant.available);
        addBtn.textContent = canBuy
          ? (window.variantStrings ? window.variantStrings.addToCart : "Add to cart")
          : (window.variantStrings ? window.variantStrings.soldOut : "Sold out");
        addBtn.disabled = !canBuy;
        addBtn.dataset.variantId = variant ? variant.id : "";

        optionsEl.querySelectorAll("[data-reco-swatch]").forEach(function (el) {
          el.classList.toggle(
            "mt-reco-card__swatch--active",
            el.getAttribute("data-reco-value") === selected[colorIndex]
          );
        });
        optionsEl.querySelectorAll("[data-reco-size]").forEach(function (el) {
          el.classList.toggle(
            "mt-reco-card__size--active",
            el.getAttribute("data-reco-value") === selected[sizeIndex]
          );
        });
      }

      if (colorIndex !== -1) {
        var swatchRow = document.createElement("div");
        swatchRow.className = "mt-reco-card__swatches";
        uniqueValues(colorIndex).forEach(function (value) {
          var btn = document.createElement("button");
          btn.type = "button";
          btn.className = "mt-reco-card__swatch";
          btn.setAttribute("data-reco-swatch", "");
          btn.setAttribute("data-reco-value", value);
          btn.setAttribute("aria-label", value);
          // Color real (igual que en la ficha de producto), no una foto en miniatura.
          btn.style.background = mtSwatchColor(value);
          btn.addEventListener("click", function () {
            selected[colorIndex] = value;
            updateUI();
          });
          swatchRow.appendChild(btn);
        });
        optionsEl.appendChild(swatchRow);
      }

      if (sizeIndex !== -1) {
        var sizeRow = document.createElement("div");
        sizeRow.className = "mt-reco-card__sizes";
        uniqueValues(sizeIndex).forEach(function (value) {
          var btn = document.createElement("button");
          btn.type = "button";
          btn.className = "mt-reco-card__size";
          if (!isValueAvailable(sizeIndex, value)) btn.classList.add("mt-reco-card__size--unavailable");
          btn.setAttribute("data-reco-size", "");
          btn.setAttribute("data-reco-value", value);
          btn.textContent = value;
          btn.addEventListener("click", function () {
            selected[sizeIndex] = value;
            updateUI();
          });
          sizeRow.appendChild(btn);
        });
        optionsEl.appendChild(sizeRow);
      }

      addBtn.addEventListener("click", function () {
        var variantId = addBtn.dataset.variantId;
        if (!variantId || !window.routes) return;
        addBtn.disabled = true;
        var originalText = addBtn.textContent;
        fetch(window.routes.cart_add_url, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
        })
          .then(function (response) {
            if (!response.ok) throw new Error("add failed");
            return response.json();
          })
          .then(function () {
            mtRefreshCartAndPublish("mt-cart-reco");
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = originalText;
          });
      });

      updateUI();
      return card;
    }

    function fillRecoContainer(container, products, seedColor) {
      var track = container.querySelector("[data-mt-reco-track]");
      if (!track) return;
      track.innerHTML = "";

      // Cada tarjeta se intenta por separado: si un producto en concreto
      // tiene datos que hacen fallar su tarjeta, no debe ocultar las
      // demás ni dejar la sección entera en blanco.
      var built = 0;
      for (var i = 0; i < products.length && built < 6; i++) {
        try {
          var card = renderRecoCard(products[i], seedColor);
          track.appendChild(card);
          built++;
        } catch (e) {}
      }
      container.hidden = !built;
    }

    // Puede haber más de un sitio con "You may also like" en la misma
    // página (el carrito desplegable es global y convive con, por
    // ejemplo, la página /cart) — se rellenan todos con la misma consulta.
    //
    // IMPORTANTE: al añadir un producto desde la ficha, el propio tema
    // sustituye TODO el contenido del carrito por HTML nuevo del servidor
    // justo después de publicar el evento "cart-update" — sin esperar a
    // nada más. Si aquí cogiéramos los contenedores ANTES de hacer el
    // fetch, para cuando la respuesta llegara ya estaríamos rellenando
    // elementos viejos, fuera del DOM visible. Por eso
    // document.querySelectorAll se hace DESPUÉS del fetch, nunca antes,
    // para operar siempre sobre el carrito que está realmente en
    // pantalla en ese momento.
    function loadRecommendations(cartData) {
      var real = realItems(cartData);
      if (!real.length) {
        document.querySelectorAll("[data-mt-cart-recommendations]").forEach(function (c) {
          c.hidden = true;
        });
        return;
      }
      var seedItem = real[real.length - 1];
      var seedId = seedItem.product_id;
      var seedColorEntry = (seedItem.options_with_values || []).filter(function (o) {
        return /colou?r/i.test(o.name || "");
      })[0];
      var seedColor = seedColorEntry ? seedColorEntry.value : null;
      var excludeIds = (cartData.items || []).map(function (i) { return i.product_id; });

      fetch("/recommendations/products.json?product_id=" + seedId + "&limit=12&intent=related")
        .then(function (response) { return response.json(); })
        .then(function (data) {
          var products = (data.products || []).filter(function (p) {
            return excludeIds.indexOf(p.id) === -1;
          });

          // Mismo tono que el producto del carrito primero, si lo hay; el resto
          // mantiene el orden de relevancia que ya devuelve Shopify. Si algo
          // en los datos de un producto no encaja (campo inesperado, etc.),
          // no debe tirar abajo toda la lista: seguimos con el orden normal.
          if (seedColor) {
            try {
              var matching = [];
              var rest = [];
              products.forEach(function (p) {
                var hasColor = (p.variants || []).some(function (v) {
                  return (p.options || []).some(function (opt, i) {
                    return /colou?r/i.test((opt && opt.name) || "") && v["option" + (i + 1)] === seedColor;
                  });
                });
                (hasColor ? matching : rest).push(p);
              });
              products = matching.concat(rest);
            } catch (e) {}
          }

          // Contenedores leídos AHORA, con los datos ya en mano — no antes.
          document.querySelectorAll("[data-mt-cart-recommendations]").forEach(function (container) {
            fillRecoContainer(container, products, seedColor);
          });
        })
        .catch(function () {
          document.querySelectorAll("[data-mt-cart-recommendations]").forEach(function (c) {
            c.hidden = true;
          });
        });
    }

    document.addEventListener("click", function (e) {
      var prevBtn = e.target.closest("[data-mt-reco-prev]");
      var nextBtn = e.target.closest("[data-mt-reco-next]");
      if (!prevBtn && !nextBtn) return;
      var wrapper = (prevBtn || nextBtn).closest(".mt-cart-reco");
      var track = wrapper && wrapper.querySelector("[data-mt-reco-track]");
      if (!track) return;
      var cardWidth = track.clientWidth;
      track.scrollBy({ left: prevBtn ? -cardWidth : cardWidth, behavior: "smooth" });
    });

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData) loadRecommendations(event.cartData);
      });
    }

    if (window.routes && window.routes.cart_url) {
      fetch(window.routes.cart_url + ".js")
        .then(function (r) { return r.json(); })
        .then(function (cartData) { loadRecommendations(cartData); })
        .catch(function () {});
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveal();
    initContadores();
    initCarruselResenas();
    initSelectorVariantes();
    initNivelesCantidad();
    initGaleriaProducto();
    initLightboxProducto();
    initPolicyAccordion();
    initShippingProtectionToggle();
    initShippingProtectionAutoClean();
    initCartRecommendations();
  });

  // El editor de temas de Shopify vuelve a dibujar una sección por AJAX cada
  // vez que se selecciona/edita (evento "shopify:section:load"). Esos elementos
  // nuevos nunca han sido observados por el IntersectionObserver de initReveal,
  // así que sin esto se quedarían con opacity:0 para siempre (invisibles) dentro
  // del editor. Lo volvemos a ejecutar para esa sección en concreto.
  document.addEventListener("shopify:section:load", function (event) {
    var els = event.target.querySelectorAll(".mt-reveal");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("mt-visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18, rootMargin: "0px 0px -8% 0px" }
    );
    els.forEach(function (el) { obs.observe(el); });
  });
})();
